import { LogsButton } from "@/components/Button";
import { Flex, Text, Image, useDisclosure } from "@chakra-ui/react";
import AddIcon from "./assets/add.png";
import SelectAvatar from "./SelectAvatar";
import { useState } from "react";
import { emojis } from "@/utils/avatars";
import EditIcon from "./assets/edit.png";

const CreateOrgFirst = ({
  loading,
  handleStep,
}: {
  loading: boolean;
  handleStep: (step: number) => void;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [avatarIndex, setAvatarIndex] = useState(
    Math.floor(Math.random() * emojis.length)
  );

  const handleOnAvatarChange = (index: number) => {
    setAvatarIndex(index);
    onClose();
  };
  return (
    <Flex
      sx={{
        height: "100%",
        width: "100%",
      }}
      alignItems="center"
      flexDir={"column"}
    >
      <Text
        sx={{
          width: "100%",
          marginTop: "30px",
          fontSize: "20px",
        }}
      >
        Set Emoji Avatar
      </Text>
      <Flex
        sx={{
          width: "100px",
          height: "100px",
          background: "#fff",
          borderRadius: "50%",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          fontSize: "72px",
          marginTop: "10vh",
          position: "relative",
        }}
        align={"center"}
        justify={"center"}
      >
        {emojis[avatarIndex]}
        <Image
          src={EditIcon}
          sx={{
            width: "30px",
            height: "30px",
            position: "absolute",
            bottom: "-15px",
            left: "50%",
            transform: "translateX(-50%)",
          }}
          onClick={onOpen}
        ></Image>
      </Flex>
      <LogsButton
        onClick={() => {
          handleStep(avatarIndex);
        }}
        loading={loading}
        sx={{
          marginTop: "auto",
        }}
      >
        Confirm
      </LogsButton>
      <SelectAvatar
        isOpen={isOpen}
        onClose={onClose}
        handleOnAvatarChange={handleOnAvatarChange}
      />
    </Flex>
  );
};

export default CreateOrgFirst;
